<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    min-height="min-h-[200px]"
    @close="$emit('close')"
  >
    <div class="book-now-inputs flex flex-col gap-3 px-3">
      <div class="-mt-4 text-left">
        <h4 class="text-xl text-steel-1100">Contact Broker</h4>
      </div>

      <div class="flex-between">
        <p class="text-sm text-steel-700">Name</p>

        <p class="text-right text-sm text-steel-800">
          {{ contactInformation?.name }}
        </p>
      </div>

      <div class="flex-between">
        <p class="text-sm text-steel-700">Phone</p>

        <p class="text-right text-sm text-steel-800">
          {{
            formatPhoneParenthesis(
              contactInformation?.phone_number,
              contactInformation?.phone_extension
            ) || '-'
          }}
        </p>
      </div>

      <div class="flex-between">
        <p class="text-sm text-steel-700">Email</p>

        <a
          v-if="contactInformation?.email"
          :href="`mailto:${contactInformation?.email}`"
          class="text-right text-sm text-sun-800 underline"
        >
          {{ contactInformation?.email }}
        </a>

        <p
          v-else
          class="text-right text-sm text-steel-800"
        >
          -
        </p>
      </div>

      <div class="my-4 flex justify-end gap-4">
        <ButtonComponent
          variant="subtle"
          @click="$emit('close')"
        >
          Done
        </ButtonComponent>
      </div>
    </div>
  </bottom-sheet>
</template>

<script setup>
import { BottomSheet, ButtonComponent } from '@/components';
import { formatPhoneParenthesis } from '@/common';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  contactInformation: {
    type: Object,
  },
});

defineEmits(['close']);
</script>
